import { connect } from "react-redux";
import { Outlet, useLocation } from "react-router";

import Sidebar from "./sidebar/Sidebar";
import { NO_NESTED_SIDEBAR_ROUTES } from "../../constants";
import { createCompanyDynamicUrl } from "../../shared/utility";
import GlobalTopbar from "../../shared/components/topbar/GlobalTopbar";

const AppLayout = ({
  isSidebarOpen,
  isNestedSidebarOpen,
  spinnerArray,
  ...props
}) => {
  const location = useLocation();

  let noNestedSideRoutes = NO_NESTED_SIDEBAR_ROUTES.map((route) =>
    createCompanyDynamicUrl(route)
  );

  return (
    <>
      <div className="page-wrapper">
        <GlobalTopbar />
        <div className={`d-flex`}>
          <Sidebar />
          <div
            className={`outlet-container ps-2 pe-1 ${
              isNestedSidebarOpen &&
              !noNestedSideRoutes.includes(location.pathname) &&
              "sidebar-opened-outlet-container"
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
  isSidebarOpen: state.system.isSidebarOpen,
  isNestedSidebarOpen: state.system.isNestedSidebarOpen,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
